import OnboardingGroup, {
  IOnboardingGroup,
  IOnboardingGroupApi,
  IPaginationResultGroups,
} from './OnboardingGroup.model';

export interface IdentifiedOnboardingGroup {
  matchedTo: string;
  groups: IOnboardingGroup[];
}

export interface IIdentifiedOnboardingGroupApi {
  _id: string;
  groups: IOnboardingGroupApi[];
}

export default class IdentifiedOnboardingGroupMapper {
  static arrayPaginatedFromApiModel(
    data: IPaginationResultGroups<IIdentifiedOnboardingGroupApi>,
  ): IPaginationResultGroups<IdentifiedOnboardingGroup> {
    return {
      ...data,
      assets: this.fromApiModel(data.assets),
    };
  }

  static fromApiModel(
    apiModels: IIdentifiedOnboardingGroupApi[],
  ): IdentifiedOnboardingGroup[] {
    return apiModels.map(
      (model: IIdentifiedOnboardingGroupApi): IdentifiedOnboardingGroup => ({
        matchedTo: model._id,
        groups: OnboardingGroup.arrayFromApiModel(model.groups),
      }),
    );
  }
}
